import React from 'react'
import Padding from './Padding';
import AnimateOnScroll from '../components/AnimateOnScroll';
import { useNavigate } from 'react-router-dom';

function withNavigation(Component) {
  return props => <Component {...props} navigate={useNavigate()} />;
}

class OurServices extends React.Component {
    render() {
        const { navigate } = this.props;
        return (


            <div id="OurServices" style={{ backgroundColor: "#000010" }}>

                <Padding />
                <Padding />

                <div className="container-text">
                    <h2>Our Services</h2>
                    <div id="services-content" style={{ padding: '10px' }}>

                        <p></p>

                        <div className='services-row' >
                            <div className='column'>
                                <p>We are committed to meeting the needs of our customers. Employing modern technology we craft innovative, scalable, and efficient software. If you have a specific interest in a particular technology let us know!</p>
                            </div>
                        </div>
                        <div className='services-row' >

                            <div className='services-column' onClick={() => navigate('/Services/SoftwareDevelopment')}>
                                <AnimateOnScroll direction="up" duration={500}>
                                    <h3>Software Development</h3>
                                    <p>Designing and developing specialised bespoke software solutions. Deploying the technology most suitable for the requirements.</p>
                                </AnimateOnScroll>
                            </div>

                            <div className='services-column' onClick={() => navigate('/Services/RoboticsAutomation')}>
                                <AnimateOnScroll direction="up" duration={500}>
                                    <h3>Robotics & Automation</h3>
                                    <p>Writing and optimising code to control and coordinate robot movements with other systems, ensuring precision and efficiency.</p>
                                </AnimateOnScroll>
                            </div>

                            <div className='services-column' onClick={() => navigate('/Services/ControlSystemIntegration')}>
                                <AnimateOnScroll direction="up" duration={500}>
                                    <h3>Control System Integration</h3>
                                    <p>Integrating custom software with a variety of control systems, including PLCs and other automation hardware. Including development of custom device drivers.</p>
                                </AnimateOnScroll>
                            </div>

                            <div className='services-column' onClick={() => navigate('/Services/DatabaseLIMS')}>
                                <AnimateOnScroll direction="up" duration={500}>
                                    <h3>Database and LIMS</h3>
                                    <p>We offer cutosmised solutions that enhance data management, accessibility, and analytical capabilities for our clients. </p>
                                </AnimateOnScroll>
                            </div>

                            <div className='services-column' onClick={() => navigate('/Services/MachineVision')}>
                                <AnimateOnScroll direction="up" duration={500}>
                                    <h3>Machine Vision</h3>
                                    <p>Creating vision applications ranging from basic vision sensors to comprehensive multi-camera vision systems utilising the latest technologies in AI and Machine Learning.</p>
                                </AnimateOnScroll>
                            </div>

                            <div className='services-column' onClick={() => navigate('/Services/IoT')}>
                                <AnimateOnScroll direction="up" duration={500}>
                                    <h3>IoT</h3>
                                    <p>Producing custom software to enable the development of IoT-connected devices and Cloud services.</p>
                                </AnimateOnScroll>
                            </div>

                            <div className='services-column' onClick={() => navigate('/Services/AIMachineLearning')}>
                                <AnimateOnScroll direction="up" duration={500}>
                                    <h3>AI & Machine Learning</h3>
                                    <p>Implementing modern AI solutions using Large Language Models (LLMs), Supervised Learning Models, Prompt Engineering and secure API integration.</p>
                                </AnimateOnScroll>
                            </div>
{/* 
                            <div className='services-column'>
                                <AnimateOnScroll direction="up" duration={500}>
                                    <h3>Human-Machine Interface (HMI)</h3>
                                    <p>Creating intuitive and user-friendly interfaces that allow operators to interact with and monitor automated systems.</p>
                                </AnimateOnScroll>
                            </div> */}

                            {/* <div className='services-column'>
                        <Fade>
                        <h3>Simulation and Testing</h3>
                        <p>Conducting thorough simulation and testing of the software to validate its performance and identify any potential issues before deployment.</p>
                        </Fade>
                    </div> */}

                            {/* <div className='services-column'>
                        <Fade>
                        <h3>Real-time Monitoring and Reporting</h3>
                        <p>Implementing features for real-time monitoring of automation processes and generating detailed reports for performance analysis and optimization.</p>
                        </Fade>
                    </div> */}
                            {/*     
                    <div className='services-column'>
                        <Fade>
                        <h3>Safety Systems Integration</h3>
                        <p>Incorporating safety protocols and systems within the software to ensure compliance with industry standards and regulations.</p>
                        </Fade>
                    </div> */}
                            <div className='services-column' onClick={() => navigate('/Services/MaintenanceSupport')}>
                                <AnimateOnScroll direction="up" duration={500}>
                                    <h3>Maintenance and Support</h3>
                                    <p>Providing ongoing maintenance and support services to address issues, apply updates, and ensure the continued reliability of a system.</p>
                                </AnimateOnScroll>
                            </div>
                            <div className='services-column' onClick={() => navigate('/Services/Training')}>
                                <AnimateOnScroll direction="up" duration={500}>
                                    <h3>Training</h3>
                                    <p>Offering training programs and comprehensive documentation to empower client teams.</p>
                                </AnimateOnScroll>
                            </div>


                        </div>

                    </div>
                </div>

                <Padding />
                <Padding />
            </div>

        )
    }
}

export default withNavigation(OurServices);

